
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-rated-medicare-advantage",
      function () {
        return require("private-next-pages/top-rated-medicare-advantage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top-rated-medicare-advantage"])
      });
    }
  